module.exports = __webpack_public_path__ + "img/ic-contact-line.be498e3a.png";